import React from "react";
import { AddInfo } from ".";
import GlobalSettingsAction from "./GlobalSettingsAction";

function FloatRight() {
  return (
    <div className="d-flex align-items-center">
      <GlobalSettingsAction />
      <AddInfo />
    </div>
  );
}

export default FloatRight;
